import React from "react";
import { Routes, Route } from "react-router-dom";
import { AppProvider } from "./context/AppContext";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./components/Home";
import About from "./components/About";
import Register from "./components/Register";
import Login from "./components/Login";
import ForgotPassword from "./components/ForgotPassword";
import ResetPassword from "./components/ResetPassword";
import Artists from "./components/Artists";
import ArtistProfile from "./components/ArtistProfile";
import Gallery from "./components/Gallery";
import Events from "./components/EventsPage";
import News from "./components/News";
import ArtNews from "./components/ArtNews";
import SearchPage from "./components/SearchPage";
import EditProfile from "./components/EditProfile";
import MediaPress from "./components/MediaPress";
import Dashboard from "./components/Dashboard";
import "bootstrap/dist/css/bootstrap.min.css";
import "./theme.css";
import "./App.css";

function App() {
  return (
    <AppProvider>
      <div className="App">
        <Header />
        <Routes>
          <Route path="/"            element={<Home />} />
          <Route path="/artists"     element={<Artists />} />
          <Route path="/artists/:id" element={<ArtistProfile />} />
          <Route path="/gallery"     element={<Gallery />} />
          <Route path="/events"      element={<Events />} />
          <Route path="/news"        element={<News />} />
          <Route path="/art-news"    element={<ArtNews />} />
          <Route path="/about"       element={<About />} />
          <Route path="/search"      element={<SearchPage />} />
          <Route path="/register"        element={<Register />} />
          <Route path="/login"           element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password"  element={<ResetPassword />} />
          <Route path="/edit-profile"    element={<EditProfile />} />
          <Route path="/dashboard"       element={<Dashboard />} />
          <Route path="/media"           element={<MediaPress />} />
        </Routes>
        <Footer />
      </div>
    </AppProvider>
  );
}
export default App;
